import React, { Component } from "react";
// @material-ui/core components
import { EmptyRecord } from "../../utils/PageUtility";
import withStyles from "@material-ui/core/styles/withStyles";
import RecordPagination from "../../utils/RecordsPagination";
import Button from "components/CustomButtons/Button.jsx";
import Edit from "@material-ui/icons/Edit";
import Approve from "@material-ui/icons/DoneOutline";
import Decline from "@material-ui/icons/Close";
import { appHelpers } from "../../_helpers";

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Grid,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { appConstants } from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  icon: {
    margin: "8px 0px 8px 8px",
    position: "relative",
    top: "7px",
    paddingLeft: "8px",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  searchButton: {
    backgroundColor: " #66bb6a",
  },
});
const SettingTableStructure = ({
  filterAirport,
  classes,
  pageSize,
  pageIndex,
  currentPage,
  handleApproveToken,
  records,
  filterUsers,
  user,
  handleEdit,
  filterAirlines,
}) => (
  <Table className={classes.table} aria-labelledby="tableTitle">
    <TableHead className={classes.negativeColor} color="primary">
      <TableRow>
        <TableCell padding="none">S/N</TableCell>
        <TableCell padding="none">Airline</TableCell>
        <TableCell padding="none">Airport</TableCell>
        <TableCell padding="none">Old Re-order Level</TableCell>
        <TableCell padding="none">New Re-order Level</TableCell>
        <TableCell padding="none">Created By </TableCell>
        <TableCell padding="none">Status </TableCell>
        <TableCell padding="none">Action</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {records &&
        records.map((item, key) => {
          return (
            <TableRow hover key={key}>
              <TableCell padding="none" className={"text-capitalize"}>
                {pageIndex + key}
                {/*{currentPage === 1 ? key + 1 : (pageSize * currentPage) + key + 1}*/}
              </TableCell>
              <TableCell padding="none" className={"text-capitalize"}>
                {filterAirlines(item.AirlineId)}
              </TableCell>
              <TableCell padding="none" className={"text-capitalize"}>
                {filterAirport(item.AirportCode)}
              </TableCell>
              <TableCell padding="none" component="th">
                {appHelpers.numberWithCommasOnly(item.OldAmount)}
              </TableCell>
              <TableCell padding="none" component="th">
                {`${item.Currency} ${appHelpers.numberWithCommasOnly(
                  item.NewAmount
                )}`}
              </TableCell>
              <TableCell padding="none">
                {item.CreatedBy ? filterUsers(item.CreatedBy) : "N/A"}
              </TableCell>
              <TableCell padding="none">
                {item.IsApproved === null && <span>Pending</span>}
                {item.IsApproved === false && (
                  <span style={{ color: "#dd2735" }}>Declined</span>
                )}
                {item.IsApproved === true && (
                  <span style={{ color: "#66bb6a" }}>Approved</span>
                )}
              </TableCell>
              <TableCell padding="none">
                {item.CreatedBy === user.userId && item.IsApproved === null ? (
                  <span
                    style={{ cursor: "pointer", color: "#dd2735" }}
                    onClick={() => handleEdit(item)}
                  >
                    <span className={classes.icon}>
                      {" "}
                      <Edit />
                    </span>{" "}
                    Edit
                  </span>
                ) : (
                  ""
                )}
                {item.CreatedBy !== user.userId && item.IsApproved === null ? (
                  <span>
                    <span
                      onClick={() => handleApproveToken(0, item.Id)}
                      style={{ cursor: "pointer", color: "#dd2735" }}
                    >
                      <span className={classes.icon}>
                        {" "}
                        <Decline />{" "}
                      </span>
                      Decline
                    </span>
                    <span
                      onClick={() => handleApproveToken(1, item.Id)}
                      style={{ cursor: "pointer", color: "#66bb6a" }}
                      autoFocus
                    >
                      <span className={classes.icon}>
                        <Approve />{" "}
                      </span>
                      Approve
                    </span>
                  </span>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
          );
        })}
    </TableBody>
  </Table>
);

class AllThresholdsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      flight: false,
    };
  }

  handleClickOpen = (flight) => {
    this.setState({ open: true });
    this.setState({ flight });
    this.props.fetchFlightPassengers(flight.Id);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      airports,
      airportCode,
      filterAirport,
      airlinesData,
      status,
      statusFilter,
      reactSelectChange,
      handleSearch,
      pageSize,
      airline,
      classes,
      totalCounts,
      handleEdit,
      handleApproveToken,
      filterUsers,
      fetchRecords,
      currentPage,
      user,
      records,
      filterAirlines,
    } = this.props;
    const pageIndex = pageSize * (currentPage - 1) + 1;
    
    return (
      <div>
        <Grid container spacing={24}>
          <Grid item md={3} sm={12}>
            <FormControl className={classes.formControl}>
              <InputLabel shrink htmlFor="age-simple">
                Airlines
              </InputLabel>
              <AutocompleteSelect
                options={airlinesData.map((option) => ({
                  value: option.AirlineId,
                  label: option.Airline,
                }))}
                selectedOption={airline}
                handleSelectChange={(e, name) => reactSelectChange(e, name)}
                name={"airline"}
                disabled={user.AppRole === appConstants.ROLES.AIRLINE}
              />
            </FormControl>
          </Grid>

          <Grid item md={3} sm={12}>
            <FormControl className={classes.formControl}>
              <InputLabel shrink htmlFor="age-simple">
                Airports
              </InputLabel>
              <AutocompleteSelect
                options={airports.map((option) => ({
                  value: option.Code,
                  label: option.Name,
                }))}
                selectedOption={airportCode}
                handleSelectChange={(e, name) => reactSelectChange(e, name)}
                // selectLabel={"Airlines"}
                name={"airportCode"}
                disabled={
                  user.AppRole === appConstants.ROLES.AIRPORT_MANAGER ||
                  user.Location
                }
              />
            </FormControl>
          </Grid>

          <Grid item md={3} sm={12}>
            <FormControl className={classes.formControl}>
              <InputLabel shrink htmlFor="age-simple">
                Status
              </InputLabel>
              <AutocompleteSelect
                options={status.map((option) => ({
                  value: option.value,
                  label: option.name,
                }))}
                selectedOption={statusFilter}
                handleSelectChange={(e, name) => reactSelectChange(e, name)}
                name={"statusFilter"}
              />
            </FormControl>
          </Grid>
          <Grid item md={3} sm={12}>
            <Button color={"regional"} onClick={() => handleSearch()}>
              Search
            </Button>
          </Grid>
        </Grid>

        {totalCounts === 0 && (
          <EmptyRecord message={"No pending re-order level yet!"} />
        )}

        {totalCounts !== 0 && (
          <Grid container spacing={24}>
            <Grid item md={12} sm={12}>
              <div
                className={classes.tableResponsive}
                style={{ overflowX: "auto" }}
              >
                <RecordPagination
                  fetchMore={fetchRecords}
                  totalCount={totalCounts}
                  pageSize={pageSize}
                  currentPage={currentPage}
                  target={
                    <SettingTableStructure
                      records={records}
                      pageSize={pageSize}
                      currentPage={currentPage}
                      classes={classes}
                      filterUsers={filterUsers}
                      handleEdit={handleEdit}
                      handleApproveToken={handleApproveToken}
                      user={user}
                      filterAirlines={filterAirlines}
                      filterAirport={filterAirport}
                      pageIndex={pageIndex}
                    />
                  }
                />
              </div>
            </Grid>
          </Grid>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(AllThresholdsTable);



// WEBPACK FOOTER //
// ./src/Regional-Views/Settings/allThresholdsTable.js